<p>show-daily-payments works!</p>
